import React from "react";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import styles from "./ListingThankyouView.module.css";
import { listingStates } from "../../util/flStates";
import { Box, Button, Typography } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

const ListingThankyouView = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { listingId, listingUrl, listingType } = location.state || {};

  const getSpecialString = (listingType) => {
    switch (listingType) {
      case listingStates.rent:
        return "Rent-Homes";
      case listingStates.sell:
        return "Buy-Homes";
      default:
        return "listings";
    }
  };

  const handleUpgrade = async () => {
    // console.log("Upgrade it", listingId);
    navigate("/Landlord/Payment", {
      state: { listingId: listingId || null },
    });
  };

  return (
    <div className={styles.pageContainer}>
      <Navbar />
      <Box
        sx={{
          textAlign: "center",
          padding: "2rem",
          border: "1px solid #4CAF50",
          borderRadius: "8px",
          backgroundColor: "#E8F5E9",
        }}
      >
        <CheckCircleOutlineIcon sx={{ fontSize: 60, color: "#4CAF50" }} />
        <Typography variant="h4" sx={{ color: "#4CAF50", marginTop: "1rem" }}>
          Listing created successfully!
        </Typography>
        <div style={{marginTop: "10px"}}>
          Your property listing has been successfully created and is now visible
          to potential renters.
        </div>
        <Box sx={{ marginTop: "2rem" }}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => navigate("/landlord")}
            sx={{ margin: "0.5rem" }}
          >
            Add Another Property
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => navigate("/MyFirstLand?category=listings")}
            sx={{ margin: "0.5rem" }}
          >
            View All Listings
          </Button>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => {
              const specialString = getSpecialString(listingType);
              window.open(
                `${import.meta.env.VITE_FRONTEND_URL}/${specialString}/${listingUrl}`,
                "_blank"
              );
            }}
            sx={{ margin: "0.5rem" }}
          >
            View Live Listing
          </Button>
        </Box>
      </Box>
      <div className={styles.container}>
        {listingId ? (
          <div className={styles.messageBox}>
            <h2 className={styles.successMessage}>
              Listing Created Successfully!
            </h2>
            <p className={styles.description}>
              Your property listing has been successfully created and is now
              visible to potential renters.
            </p>
            <div className={styles.premiumSection}>
              <h3 className={styles.premiumTitle}>Upgrade to Premium</h3>
              <p className={styles.premiumText}>
                Do you want to take the Premium Service for your listing?
              </p>
              <div className={styles.benefitsList}>
                <h4>Benefits Included:</h4>
                <ul>
                  <li>Feature at the top of search results</li>
                  <li>Highlighted listing with a premium badge</li>
                  <li>Promoted on the homepage banner</li>
                  <li>Advanced analytics and performance insights</li>
                </ul>
              </div>
              <button className={styles.upgradeButton} onClick={handleUpgrade}>
                Upgrade to Premium
              </button>
            </div>
          </div>
        ) : (
          <div className={styles.unauthorizedMessage}>Unauthorized access</div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default ListingThankyouView;
